import React, {useState} from 'react';
import axios from '../Common/axios';
import { Modal, Spin } from "antd";
import {getGridTableHeight} from '../Common/util';
import {postModifyResultData} from '../../pages/Common/api';
import { SearchOutlined } from '@ant-design/icons';
import { applyTimeRanges } from '../Common/options';

import PlanTable from './PlanTable.js';

/** -------------------------------------------------------------------------- **/
function Plan({companyCode, reportId, planList, setIsDataChange, spinflagMain}) {

    // Table 선택박스 설정
    const [spinflag, setSpinflag] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]); 
    const onSelectChange = (newSelectedRowKeys) => {
        //console.log('selectedRowKeys changed: ', newSelectedRowKeys);
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };
    const titleName="위험관리계획";
    //----------------------------------------------------------------------------------------
    // 저장 클릭 시
    const onClickSaveHandler = (saveData) => {

        // 변경건이 있으면 추가
        if(saveData.length > 0) {
            saveModifyVaResultData(saveData);
        } else {
            Modal.info({title:titleName, content:"변경된 데이타가 없습니다.", okText:"Close"});
        }

    }

    // 위험관리계획 수정 API
    const saveModifyVaResultData = (saveData) => {
        setIsDataChange(false);
        setSpinflag(true);
        
        let saveDataLen = saveData.length;

        for(let i=0; i < saveDataLen; i++){
            // 위험감소-장기, 위험수용, 위험이전, 위험회피는 사유 필수
            if((saveData[i].apply_action == "위험감소" && saveData[i].apply_time=="장기") || 
               (saveData[i].apply_action == "위험수용") ||
               (saveData[i].apply_action == "위험이전") ||
               (saveData[i].apply_action == "위험회피")) {
                if(saveData[i].action_remark=="" || saveData[i].action_remark=="사유를 반드시 적어주세요!"){
                    Modal.info({title:titleName, content:"사유를 반드시 적어주세요!", okText:"Close"});  
                    setSpinflag(false);
                    return;
                }
            }
            
            // action_time 처리: 사용자가 지정하지 않은 경우 제거
            if(saveData[i].apply_action == "위험감소") {
                // action_time이 비어있거나 기본값이면 제거 (백엔드에서 결정)
                if(!saveData[i].action_time || saveData[i].action_time === "") {
                    delete saveData[i].action_time;
                } else if(saveData[i].action_time && saveData[i].apply_time) {
                    // action_time이 있고 apply_time도 있으면 조건 검증
                    const actionDate = new Date(saveData[i].action_time);
                    // sys_reg_date를 기준으로 사용 (없으면 오늘 날짜)
                    const baseDate = saveData[i].sys_reg_date ? new Date(saveData[i].sys_reg_date) : new Date();
                    baseDate.setHours(0, 0, 0, 0); // 시간 부분 초기화
                    actionDate.setHours(0, 0, 0, 0);
                    // 날짜 차이 계산 (일 단위) - 하루 차감 필요 
                    const diffTime = actionDate - baseDate;
                    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))-1;
                    // apply_time에 따른 검증
                    let isValid = true;
                    let errorMsg = "";
                    
                    const baseDateStr = saveData[i].sys_reg_date ? 
                        new Date(saveData[i].sys_reg_date).toLocaleDateString('ko-KR') : '오늘';
                    
                    const timeRange = applyTimeRanges[saveData[i].apply_time];
                    
                    if(timeRange) {
                        if(diffDays < timeRange.min || diffDays > timeRange.max) {
                            isValid = false;
                            const rangeText = saveData[i].apply_time === '단기' ? '3개월 이내' :
                                            saveData[i].apply_time === '중기' ? '3개월 초과 12개월 이내' :'1년 초과';
                            errorMsg = `${saveData[i].apply_time} 조치일정은 기준일(${baseDateStr})부터 ${rangeText}(${timeRange.min}일~${timeRange.max}일)여야 합니다.`;
                        }
                    }
                    
                    if(!isValid) {
                        Modal.info({title:titleName, content:errorMsg, okText:"Close"});
                        setSpinflag(false);
                        return;
                    }
                }
            }
        }

        axios.post(postModifyResultData()
                        , {reportId : reportId, resultType : 'C', saveData : saveData}
                        , {logCompany : companyCode, logParam : reportId})
        .then((response) => {
            //console.log(response);
            if(response.data.status==="success" || response.data.message == '취약점 분석 결과 수정 및 위험 평가 완료') {
                Modal.info({title:titleName, content:response.data.message, okText:"Close", onOk() {
                    // 선택정보 초기화
                    setIsDataChange(true);
                }});
            } else {
                Modal.info({title:titleName, content:response.data, okText:"Close"});  
                // 선택정보 초기화
                setIsDataChange(true);
            }
            
            setSpinflag(false);
        })
        .catch((error) => {
            Modal.error({title:titleName, content:error.message, okText:"Close"});
            console.dir(error);
            setSpinflag(false);
        }).finally(()=>{
            setSpinflag(false);
        });
    };

    //----------------------------------------------------------------------------------------
    return (
        <Spin size={"large"}  tip={"Loading..."} spinning={spinflagMain}>
            <div id="divTabs1" className="section" style={{height:getGridTableHeight(180), overflowY:'auto'}}>
                <div className="sub_title">
                        {'■ 위험관리 계획'}
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <span style={{color:'#0378c7', fontSize:'11px', fontWeight:'normal'}}>※ [일괄적용]시 수정하고자 하는 항목에만 값을 입력해 주세요.</span>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <span style={{color:'#0378c7', fontSize:'11px', fontWeight:'normal'}}>※ <SearchOutlined />필터 적용 시, [저장]후 다음 작업 진행시 필터해제 후 진행해 주세요.</span>
                </div>
                <div style={{padding: '10px 10px'}}>
                    <PlanTable
                        data={planList}
                        columnData={[]}
                        onClickSaveHandler={onClickSaveHandler}
                        rowSelection={rowSelection}
                        selectedRowKeys={selectedRowKeys}
                        spinflag={spinflag}
                    />
                </div>
            </div>
        </Spin>
    );
}
export default Plan;